<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolStaffManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/staff-management/staff-profile",
                title: "Staff Profile",
                description: "View and manage staff profiles and employment details.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Performance Reviews",
                description: "Record staff evaluations and professional feedback.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Leave Management",
                description: "Review staff leave requests and track leave balances.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
